export default __webpack_public_path__ + "static/media/vsdigital.c1b8027e.png";